import { Text } from 'react-native-paper'
import ErrorText from './ErrorText'
import { View } from 'react-native'
import React from 'react'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { Trans, useTranslation } from 'react-i18next'

export const PasswordHint = ({ passwordValidation, testID = '' }) => {
  const { t } = useTranslation('auth')
  const style = { fontWeight: '400', fontSize: 14, lineHeight: 24 }
  return (
    <View style={{ flexDirection: 'row' }} testID={testID}>
      <Text>
        <Trans i18nKey="passwordHint" t={t}>
          Must be{' '}
          <ErrorText
            color={
              passwordValidation
                ? passwordValidation.length
                  ? commonColors.accentText
                  : commonColors.accent
                : commonColors.textLight
            }
            style={style}
          >
            8 characters
          </ErrorText>
          , include{' '}
          <ErrorText
            color={
              passwordValidation
                ? passwordValidation.uppercase
                  ? commonColors.accentText
                  : commonColors.accent
                : commonColors.textLight
            }
            style={style}
          >
            1 uppercase
          </ErrorText>{' '}
          and{' '}
          <ErrorText
            color={
              passwordValidation
                ? passwordValidation.number
                  ? commonColors.accentText
                  : commonColors.accent
                : commonColors.textLight
            }
            style={style}
          >
            1 number
          </ErrorText>
        </Trans>
      </Text>
    </View>
  )
}
